import React from "react";
import "./Portfolio.scss";
import { ReactComponent as DottedBig } from "../../assets/dotted-big.svg";
import { ReactComponent as Line } from "../../assets/line.svg";
import { ReactComponent as External } from "../../assets/external.svg";
import Section from "../../components/Section/Section";
import PortfolioItem from './components/portfolio-item'
const Portfolio = () => {
  return (
    <>
      <div className="portfolio__background">
        <div className="portfolio__background-dottedbig portfolio__background-element dottedbig">
          <DottedBig />
        </div>
      </div>
      <div className="portfolio">
        <div className="portfolio__section">
          <Section text="Portfolio">Portfolio</Section>
        </div>
        <div className="portfolio__1">
          <div className="portfolio__left">
            <div className="portfolio-line">
              <Line />
            </div>
            <div className="heading-4 portfolio__heading-4 u-color-primary">
              <span>PROJECT</span>
            </div>
            <div className="heading-1 portfolio__heading-1">
              <span className="u-color-primary">BlendJet</span> Storybook
            </div>
            <div className="paragraph portfolio__paragraph">
              <span className="u-color-primary-light">BlendJet</span> is website providing blenders.
              I developed the website as well as storybook for them using React.js and later converted it into Vue.js
            </div>
            <div className="portfolio__icons">
              <div className="portfolio__icons-icon">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://blendjet.com/"
                >
                  <External />
                </a>
              </div>
            </div>
          </div>
          <div className="portfolio__right">
            <PortfolioItem
              images = {[
                '/portfolio/blend-1.PNG',
                '/portfolio/blend-2.PNG',
                '/portfolio/blend-3.PNG',
                '/portfolio/blend-4.PNG'
              ]}
              link={"https://blendjet.com/"}
            />
          </div>
        </div>
        <div className="portfolio__2">
          <div className="portfolio__2-right">
            <div className="portfolio-line">
              <Line />
            </div>
            <div className="heading-4 portfolio__heading-4 u-color-primary">
              <span>PROJECT</span>
            </div>
            <div className="heading-1 portfolio__heading-1">
              <span className="u-color-primary">Enjinx</span> WEB SITE
            </div>
            <div className="paragraph portfolio__paragraph">
              <span className="u-color-primary-light">The goal</span> was to
              create a game item marketplace based on Enjin coin. I played the full stack engineer role
              to develop enjin cloud (which is a backend) using laravel + graphql and Vue(Vuetify) for developing the front end.
            </div>
            <div className="portfolio__icons">
              <div className="portfolio__icons-icon">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://enjinx.io/"
                >
                  <External />
                </a>
              </div>
            </div>
          </div>
          <div className="portfolio__2-left">
            <PortfolioItem
              images = {[
                '/portfolio/enjin-1.PNG',
                '/portfolio/enjin-2.PNG',
                '/portfolio/enjin-3.PNG',
                '/portfolio/enjin-4.PNG'
              ]}
              link={"https://enjinx.io/"}
            />
          </div>
        </div>
        <div className="portfolio__1">
          <div className="portfolio__left">
            <div className="portfolio-line">
              <Line />
            </div>
            <div className="heading-4 portfolio__heading-4 u-color-primary">
              <span>PROJECT</span>
            </div>
            <div className="heading-1 portfolio__heading-1">
              <span className="u-color-primary">24/7</span> Games
            </div>
            <div className="paragraph portfolio__paragraph">
              <span className="u-color-primary-light">24/7</span> Games is 
              providing various casino games. I was responsible for developing card game backends using node.js + aedes mqtt.
            </div>
            <div className="portfolio__icons">
              <div className="portfolio__icons-icon">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.247spades.com/"
                >
                  <External />
                </a>
              </div>
            </div>
          </div>
          <div className="portfolio__right">
            <PortfolioItem
              images = {[
                '/portfolio/247-1.PNG',
                '/portfolio/247-2.PNG',
                '/portfolio/247-3.PNG',
                '/portfolio/247-4.PNG'
              ]}
              link={"https://www.247spades.com/"}
            />
          </div>
        </div>
        <div className="portfolio__2">
          <div className="portfolio__2-right">
            <div className="portfolio-line">
              <Line />
            </div>
            <div className="heading-4 portfolio__heading-4 u-color-primary">
              <span>PROJECT</span>
            </div>
            <div className="heading-1 portfolio__heading-1">
              <span className="u-color-primary">Cropper</span> Finance
            </div>
            <div className="paragraph portfolio__paragraph">
              <span className="u-color-primary-light">Cropper</span> finance 
              is the ultimate yield farming protocol. It is providing various services like minting, staking, pooling and swap.
            </div>
            <div className="portfolio__icons">
              <div className="portfolio__icons-icon">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://cropper.finance/"
                >
                  <External />
                </a>
              </div>
            </div>
          </div>
          <div className="portfolio__2-left">
            <PortfolioItem
              images = {[
                '/portfolio/cropper-1.PNG',
                '/portfolio/cropper-2.PNG',
                '/portfolio/cropper-3.PNG',
                '/portfolio/cropper-4.PNG'
              ]}
              link={"https://cropper.finance/"}
            />
          </div>
        </div>
       
        <div className="portfolio__1">
        <div className="portfolio__left">
            <div className="portfolio-line">
              <Line />
            </div>
            <div className="heading-4 portfolio__heading-4 u-color-primary">
              <span>PROJECT</span>
            </div>
            <div className="heading-1 portfolio__heading-1">
              <span className="u-color-primary">MetaChess</span> Game
            </div>
            <div className="paragraph portfolio__paragraph">
              <span className="u-color-primary-light">Meatachess</span>{ " " }
              is an online chess game which is aimed to be developed as a Play to Earn Game. I played the full stack engineer role and developed the game using Node + React.
            </div>
            <div className="portfolio__icons">
              <div className="portfolio__icons-icon">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://https:/metachess.network/"
                >
                  <External />
                </a>
              </div>
            </div>
          </div>
          <div className="portfolio__right">
            <PortfolioItem
              images = {[
                '/portfolio/metachess-1.PNG',
                '/portfolio/metachess-2.PNG',
                '/portfolio/metachess-3.PNG',
                '/portfolio/metachess-4.PNG'
              ]}
              link={"https://metachess.network/"}
            />
          </div>
          
        </div>
        <div className="portfolio__2">
          <div className="portfolio__2-right">
            <div className="portfolio-line">
              <Line />
            </div>
            <div className="heading-4 portfolio__heading-4 u-color-primary">
              <span>PROJECT</span>
            </div>
            <div className="heading-1 portfolio__heading-1">
              <span className="u-color-primary">Slot</span> Games
            </div>
            <div className="paragraph portfolio__paragraph">
              Develop slot games just for fun. Going to add more slot games.
            </div>
            <div className="portfolio__icons">
              <div className="portfolio__icons-icon">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://slot-front.herokuapp.com/"
                >
                  <External />
                </a>
              </div>
            </div>
          </div>
          <div className="portfolio__2-left">
            <PortfolioItem
              images = {[
                '/portfolio/slot-1.PNG',
                '/portfolio/slot-2.PNG',
                '/portfolio/slot-3.PNG',
                '/portfolio/slot-4.PNG'
              ]}
              link={"https://slot-front.herokuapp.com/"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Portfolio;
